import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function BondsDef({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/BuyAndSellBonds");
    };

    const goPrev = () => {
        navigate("/StockFactors");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Bonds
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Bonds are essentially loans to the government or a corporation.  You buy a 
                </div>
                <div className="text-[#000000] text-3xl">
                    bond, and the government/corporation agrees to pay back the cost of the bond 
                </div>
                <div className="text-[#000000] text-3xl">
                    sometime in the future with interest payments along the way.
                </div>
                <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                    onClick={goNext}
                >
                    Next
                </button>
                <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                    onClick={goPrev}
                >
                    Prev
                </button>
            </div>
        </div>
    );
}